import { createContext } from 'react';

/**
 * - `onUomChange`: set by ProductLinesTable (must match `onChangeCell`) so the cell
 *   does not depend on ag-grid merging of `colDef.cellRendererParams`.
 */
export const SalesOrderLineUomConfirmContext = createContext({
    pendingRowId: null,
    pendingRowKey: null,
    layoutKey: 0,
    onUomChange: null,
});
